/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable object-shorthand */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-const */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-else-return */
/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table"
import moment from "moment";
import "react-table/react-table.css"
import userReceivedAPI from "../../services/userReceivedAPI";
import ExportPic from "../../images/1.svg";
import "./DashboardPersonal.css";
import pageCopy from "../../copy"

import {
  DashboardPageWrapper,
  DashboardRowOneWrapper,
  SentReceivedBoxWrapper,
  BoxContainer,
  TotalWrapper,
  SentReceivedContainer,
  ReceivedContainer,
  SentReceivedTitleWrapper,
  ExportTitleWrapper,
  GraphWrapper,
  GraphInlineWrapper,
  TableWrapper,
  OverviewWrapper,
  HistoryWrapper,
  SentRecTabContainer,
  DashboardUserBanner,
  SelectContainer,
  UserTabContainer,
  HighFiveLockup,
} from "./DashboardPersonal.style";

class DashboardPagePersonal extends Component {
    constructor(props) {
        super(props);
        this.state = {
          filtered: [],
          isSent: false,
          originalJson: [],
          json: [],
          name: props.user.name,
          received:"0",
          sent:"0",
          receivedColumns: [
            {
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >From
                </div>
              ),
              filterMethod: (filter, row) => {
                return row[filter.id] === filter.value;
              },
              Filter: ({ filter, onChange }) =>
                (
                  <div className="select_box">
                    <select 
                      onChange={event => onChange(
                        event.target.value
                        )}
                      style={{
                        fontFamily: "HelveticaNeue",
                        fontWeight: "bold",
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        height: "40px",
                        background: "transparent",
                        width: "100%", 
                      }}
                      value={filter ? filter.value : "all"}
                    >
                      <option value="">All</option>
                      {this.getSend().map((option, id) => (
                        <option key={id} value={option}>
                          {option}
                        </option>
                        ))}
                    </select>
                  </div>
                ),
              accessor: "sender",
              width: 250,
              sortable: true,
              headerStyle: {
                width: "400px",
                height: "50px", 
                display: "flex", 
                flexDirection: "column", 
                justifyContent: "center", 
                fontFamily: "HelveticaNeue-Medium", 
                fontSize: "16px" 
              },
              style: { 
                whiteSpace: "unset",
             }, 
            },{
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >Maxim
                </div>
              ),
              filterMethod: (filter, row) => {
                return row[filter.id] === filter.value;
              },
              Filter: ({ filter, onChange }) =>
                (
                  <div className="select_box">
                    <select
                      onChange={event => onChange(event.target.value)}
                      style={{
                        fontFamily: "HelveticaNeue",
                        fontWeight: "bold",
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        height: "40px",
                        background: "transparent",
                        width: "100%", 
                      }}
                      value={filter ? filter.value : "all"}
                    >
                      <option value="">All</option>
                      {this.getMax().map((option, id) => (
                        <option key={id} value={option}>
                          {option}
                        </option>
                        ))}
                    </select>
                  </div>
                ),
              accessor: "maxim",
              width: 250,
              sortable: true,
              headerStyle: { 
                height: "50px", 
                display: "flex", 
                flexDirection: "column", 
                justifyContent: "center", 
                fontFamily: "HelveticaNeue-Medium", 
                fontSize: "16px" 
              },
              style: { whiteSpace: "unset" }, 
            },{
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >Message
                </div>
              ),
              accessor: "message",
              width: 325,
              sortable: false,
              filterable: false,
              headerStyle: { 
                height: "50px", 
                display: "flex", 
                flexDirection: "column", 
                justifyContent: "center", 
                fontFamily: "HelveticaNeue-Medium", 
                fontSize: "16px" 
              },
              style: { whiteSpace: "unset" }, 
            },{
              id: "date",
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >Date
                </div>
              ),
              width: 100,
              sortable: false,
              filterable: false,
              accessor: dates => moment(dates.date).format("MMM DD YYYY"),
              headerStyle: { 
                height: "50px", 
                display: "flex", 
                flexDirection: "column", 
                justifyContent: "center", 
                fontFamily: "HelveticaNeue-Medium", 
                fontSize: "16px" 
              },
              style: { whiteSpace: "unset" }, 
            },
          ],
          sentColumns: [
            {
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >To
                </div>
              ),
              filterMethod: (filter, row) => {
                return row[filter.id] === filter.value;
              },
              Filter: ({ filter, onChange }) =>
                (
                  <div className="select_box">
                    <select
                      onChange={event => onChange(event.target.value)}
                      style={{
                        fontFamily: "HelveticaNeue",
                        fontWeight: "bold",
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        height: "40px",
                        background: "transparent",
                        width: "100%", 
                      }}
                      value={filter ? filter.value : "all"}
                    >
                      <option value="">All</option>
                      {this.getRec().map((option, id) => (
                        <option key={id} value={option}>
                          {option}
                        </option>
                        ))}
                    </select>
                  </div>
                ),
              accessor: "recipient",
              width: 250,
              sortable: true,
              headerStyle: { 
                height: "50px", 
                display: "flex", 
                flexDirection: "column", 
                justifyContent: "center", 
                fontFamily: "HelveticaNeue-Medium", 
                fontSize: "16px" 
              },
              style: { whiteSpace: "unset" }, 
            },{
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >{pageCopy[window.sessionStorage.company].valueName || "Maxim"}
                </div>
              ),
              filterMethod: (filter, row) => {
                return row[filter.id] === filter.value;
              },
              Filter: ({ filter, onChange }) =>
                (
                  <div className="select_box">
                    <select
                      onChange={event => onChange(event.target.value)}
                      style={{
                        fontFamily: "HelveticaNeue",
                        fontWeight: "bold",
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        height: "40px",
                        background: "transparent",
                        width: "100%", 
                      }}
                      value={filter ? filter.value : "all"}
                    >
                      <option value="">All</option>
                      {this.getMax().map((option, id) => (
                        <option key={id} value={option}>
                          {option}
                        </option>
                        ))}
                    </select>
                  </div>
                ),
              accessor: "maxim",
              width: 250,
              sortable: true,
              headerStyle: { 
                height: "50px", 
                display: "flex", 
                flexDirection: "column", 
                justifyContent: "center", 
                fontFamily: "HelveticaNeue-Medium", 
                fontSize: "16px" 
              },
              style: { whiteSpace: "unset" }, 
            },{
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >Message
                </div>
              ),
              accessor: "message",
              width: 325,
              sortable: false,
              filterable: false,
              headerStyle: { 
                height: "50px", 
                display: "flex", 
                flexDirection: "column", 
                justifyContent: "center", 
                fontFamily: "HelveticaNeue-Medium", 
                fontSize: "16px" 
              },
              style: { whiteSpace: "unset" }, 
            },{
              id: "date",
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >Date
                </div>
              ),
              width: 100,
              sortable: false,
              filterable: false,
              accessor: dates => moment(dates.date).format("MMM DD YYYY"),
              headerStyle: { 
                height: "50px", 
                display: "flex", 
                flexDirection: "column", 
                justifyContent: "center", 
                fontFamily: "HelveticaNeue-Medium", 
                fontSize: "16px" 
              },
              style: { whiteSpace: "unset" }, 
            },
          ]
        };
        this.handleExportClick = this.handleExportClick.bind(this);
        this.changeStateJsonToReceived = this.changeStateJsonToReceived.bind(this);
        this.changeStateJsonToSent = this.changeStateJsonToSent.bind(this);
        this.getSend = this.getSend.bind(this);
        this.getRec = this.getRec.bind(this);
        this.getMax = this.getMax.bind(this);
        this.onFilteredChangeCustom = this.onFilteredChangeCustom.bind(this);
    }

    async componentDidMount(){
      try{
        const that = this;
        const data = await userReceivedAPI()
        logger.log(data);
            that.setState({
              received: data.message[2].stats[0].overallReceived,
              sent: data.message[2].stats[0].overallSent,
              json: data.message[0].sent,
              originalJson: data.message
            })
      } catch (err) {
        logger.log(`Error Fetching Data From DB: ${err}`);
      }
    }

  onTotalTimeChange = (event) => {
    const allTime = event.target.value === 'allTime';
    const data = this.state.originalJson;
    const allTimeSent = data[0].sent.length;
    const allTimeRecieved = data[1].received.length;
    const past12MonthsSent = data[2].stats[0].overallSent;
    const past12MonthsRecieved = data[2].stats[0].overallReceived;
    this.setState({
      received: allTime ? allTimeRecieved : past12MonthsRecieved,
      sent: allTime ? allTimeSent : past12MonthsSent
    });
  }




    onFilteredChangeCustom = (value, accessor) => {
      let filtered = this.state.filtered;
      let insertNewFilter = 1;
  
      if (filtered.length) {
        filtered.forEach((filter, index) => {
          if (filter.id === accessor) {
            if (value === "" || !value.length) filtered.splice(index, 1);
            else filter.value = value;
  
            insertNewFilter = 0;
          }
        });
      }
  
      if (insertNewFilter) {
        filtered.push({ id: accessor, value: value });
      }
  
      this.setState({ filtered: filtered });
    };

    getSend = () => {
      const addedArray = [];
      let optionSend = this.state.json.map((optionData) => {
        if(!addedArray.includes(optionData.sender)){
          addedArray.push(optionData.sender)     
          return optionData.sender;
        }
      })
      optionSend = optionSend.filter(Boolean);
      return optionSend
    };

    getRec = () => {
      const addedArray = [];
      let optionRec = this.state.json.map((optionData) => {
        if(!addedArray.includes(optionData.recipient)){
          addedArray.push(optionData.recipient)     
          return optionData.recipient;
        }
      })
      optionRec = optionRec.filter(Boolean);
      return optionRec
    };

    getMax = () => {
      const addedArray = [];
      let optionMax = this.state.json.map((optionData) => {
        if(!addedArray.includes(optionData.maxim)){
          addedArray.push(optionData.maxim)     
          return optionData.maxim;
        }
      })
      optionMax = optionMax.filter(Boolean);
      return optionMax
    };    

    
    handleExportClick(evt) {
      evt.preventDefault();
      window.fetch(process.env.REACT_APP_SUBMISSION_EXPORT_API, {
          headers: {
              Authorization: `Bearer ${window.sessionStorage.accessToken}`,
          },
      })
          .then((response) => {
              if (!response.ok) {
                  throw new Error("Export error");
              }
              return response.blob();
          }).then((blob) => {
              const objectURL = window.URL.createObjectURL(blob);
              window.location = objectURL;
          }).catch((err) => {
              console.log(err);
          });
    }

    changeStateJsonToSent(){
      try{
        this.setState({
          isSent: false,
          json: this.state.originalJson[0].sent
        })
      } catch (err) {
        logger.log(`Error Login: ${err}`);
      }
    }

    changeStateJsonToReceived(){
      try{
        this.setState({
          isSent: true,
          json: this.state.originalJson[1].received
        })
      } catch (err) {
        logger.log(`Error Login: ${err}`);
      }
    }

    render() { 
        return ( 
          <DashboardPageWrapper>
            <OverviewWrapper>
              <DashboardUserBanner>
                <HighFiveLockup />
                <UserTabContainer>
                  <a
                    id="Send a High Five"
                    title="See Your High Fives"
                    href={`${window.location.origin }/dashboard`}
                    style={{ 
                      fontFamily: "HelveticaNeue-Medium",
                      fontSize: "16px",
                      paddingRight: "5px",
                      color: null,
                      height: "48px" 
                    }}
                  >
                    { this.state.name }
                  </a>
                  <a
                    id="Go to Dashboard"
                    title="See your Teams High Fives"
                    href={`${window.location.origin  }/manager-dashboard`}
                    style={{ 
                      fontFamily: "HelveticaNeue-Medium",
                      fontSize: "16px",
                      paddingLeft: "5px",
                      color: "#8d8d8d",
                      height: "48px",
                    }}
                  >
                  My Team
                  </a>
                  <a
                    id="Go to Dashboard"
                    title="Send A High Five"
                    href={`${window.location.origin }/submit`}
                    style={{ 
                      background: "#061b38",
                      color: "#ffffff",
                      padding: "1em 4em",
                      margin: "1em",
                      display: "inline-block",
                      borderRadius: "5em",
                      fontSize: "16px",
                      fontWeight: "bold",
                      lineHeight: "20px",
                    }}
                  >
                  Send A High Five
                  </a>
                </UserTabContainer>
              </DashboardUserBanner>
            </OverviewWrapper>
            <DashboardRowOneWrapper>
              <HistoryWrapper>
                <HistoryWrapper>
                  History
                </HistoryWrapper>
                <SentReceivedBoxWrapper>
                  <SentRecTabContainer>
                    <button
                      onClick={this.changeStateJsonToSent}
                      id="Sent High Fives"
                      title="Sent a High Fives"
                      style={{ 
                        outline: "0",
                        fontFamily: "HelveticaNeue-Medium",
                        fontWeight: "500px",
                        backgroundColor: "transparent",
                        border: "none",
                        borderBottom: !this.state.isSent ? "2px solid #061B38" : null,
                        color: null,
                        height: "36px" 
                      }}
                    >
                      Sent
                    </button>
                    <button
                      onClick={this.changeStateJsonToReceived}
                      id="Received High Fives"
                      title="Received High Fives"
                      style={{ 
                        outline: "0",
                        marginLeft: "20px",
                        fontFamily: "HelveticaNeue-Medium",
                        fontWeight: "500px",
                        backgroundColor: "transparent",
                        borderBottom: this.state.isSent  ? "2px solid #061B38" : null,
                        color: null,
                        height: "36px" 
                      }}
                    >
                      Received
                    </button>
                  </SentRecTabContainer>
                </SentReceivedBoxWrapper>
              </HistoryWrapper>
            </DashboardRowOneWrapper>
            <DashboardRowOneWrapper>
              <GraphWrapper>
                <GraphInlineWrapper>
                  <TableWrapper>
                    <ReactTable 
                      noDataText={this.state.isSent ? "No Received High Fives" : "No Sent High Fives"}  
                      className="-striped -highlight"
                      style={{
                        backgroundColor: "#ffffff",
                        height: "488px" // This will force the table body to overflow and scroll, since there is not enough room
                      }}
                      filterable
                      filtered={this.state.filtered}
                      onFilteredChange={(filtered, column, value) => {
                        this.onFilteredChangeCustom(value, column.id || column.accessor);
                      }}
                      defaultFilterMethod={(filter, row) => {
                        const id = filter.pivotId || filter.id;
                        if (typeof filter.value === "object") {
                          return row[id] !== undefined
                            ? filter.value.indexOf(row[id]) > -1
                            : true;
                        } else {
                          return row[id] !== undefined
                            ? String(row[id]).indexOf(filter.value) > -1
                            : true;
                        }
                      }}
                      minRows={0}
                      defaultPageSize={25}
                      data={this.state.json}
                      columns={this.state.isSent ? this.state.receivedColumns : this.state.sentColumns}
                    />
                  </TableWrapper>
                </GraphInlineWrapper>
              </GraphWrapper>
              <SentReceivedBoxWrapper>
            <TotalWrapper>
              <div>Total</div>
              <div class="select_container" style={{
                position: "relative",
                flexGrow: "1",
                display: "flex",
                alignItems: "center",
              }}>
              <SelectContainer onChange={this.onTotalTimeChange}>
                <option value="past12">Past 12 Months</option>
                <option value="allTime">All Time</option>
              </SelectContainer>
              </div>
              
            </TotalWrapper>
                <BoxContainer>
                  <SentReceivedContainer className="border-right-white">
                    {this.state.sent}
                  </SentReceivedContainer>

                  <ReceivedContainer className="outline">
                    {this.state.received}
                  </ReceivedContainer>

                  <SentReceivedTitleWrapper className="border-right-white">
                    Sent
                  </SentReceivedTitleWrapper>

                  <SentReceivedTitleWrapper>
                    Received
                  </SentReceivedTitleWrapper>

                  <ExportTitleWrapper color="#FFFFF">
                    <a
                      onClick={this.handleExportClick}
                      href={process.env.REACT_APP_SUBMISSION_EXPORT_API}
                      className="ncss-brand 
                      pt2-sm pr5-sm pb2-sm pl6-sm va-sm-b d-sm-ib"  
                    >
                      <h1 style={{color:"white"}} className="va-sm-m d-sm-ib">
                        Export CSV
                      </h1>
                      <img src={ExportPic} alt="" className="va-sm-m d-sm-ib" />
                    </a>
                  </ExportTitleWrapper>
                </BoxContainer>
              </SentReceivedBoxWrapper>
            </DashboardRowOneWrapper>
          </DashboardPageWrapper>

         );
    }
}

DashboardPagePersonal.propTypes = {
    user: PropTypes.object,
}

DashboardPagePersonal.defaultProps = {
    user: {}
}

export default DashboardPagePersonal;


// WEBPACK FOOTER //
// ./src/containers/DashboardPage/DashboardPersonal.js